import { Paper, styled, Theme } from '@mui/material';
import { COLORS } from './colors';

export const StyledContainer = styled(Paper)(({ theme }: { theme: Theme }) => ({
  borderRadius: theme.spacing(3),
  padding: theme.spacing(3, 2.5),
  backgroundColor: COLORS.black[80],
  position: 'relative',
}));
